import { GKSelect, GKTextField, Grid2, MenuItem } from "components";
import { AdvisorOnboardFormInterface } from "interfaces/OnboardingInterface";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { BANK_ACCOUNT_TYPES } from "utils/constants";

const AdvisorOnboardingClientBank = () => {
  const form = useFormContext<AdvisorOnboardFormInterface>();

  const { fields } = useFieldArray({
    control: form.control,
    name: "bankAccounts",
  });

  return (
    <Grid2 size={12} container spacing={1}>
      <Grid2 size={12}>
        {fields?.map((row: any, index) => {
          return (
            <Grid2 container size={12} spacing={1} key={row.id}>
              <Grid2 size={6}>
                <Controller
                  name={`bankAccounts.${index}.name`}
                  control={form.control}
                  rules={{
                    required: {
                      value: form.getValues("onboardingType").includes("MF"),
                      message: "Please enter Account holder name",
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <GKTextField
                      {...field}
                      requiredField={form
                        .getValues("onboardingType")
                        .includes("MF")}
                      inputLabel="Bank Account Name"
                      error={!!error}
                      helperText={error?.message}
                    />
                  )}
                />
              </Grid2>

              <Grid2 size={6}>
                <Controller
                  name={`bankAccounts.${index}.type`}
                  control={form.control}
                  rules={{
                    required: {
                      value: form.getValues("onboardingType").includes("MF"),
                      message: "Please select Account type",
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <GKSelect
                      {...field}
                      requiredField={form
                        .getValues("onboardingType")
                        .includes("MF")}
                      inputLabel="Bank Account Type"
                      error={!!error}
                      helperText={error?.message}
                    >
                      <MenuItem style={{ display: "none" }} value="">
                        Select Account Type
                      </MenuItem>
                      {BANK_ACCOUNT_TYPES?.map((dataItem) => (
                        <MenuItem value={dataItem?.value} key={dataItem?.value}>
                          {dataItem?.name}
                        </MenuItem>
                      ))}
                    </GKSelect>
                  )}
                />
              </Grid2>
              <Grid2 size={6}>
                <Controller
                  name={`bankAccounts.${index}.accountNum`}
                  control={form.control}
                  rules={{
                    required: {
                      value: form.getValues("onboardingType").includes("MF"),
                      message: "Please enter Account number",
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <GKTextField
                      {...field}
                      requiredField={form
                        .getValues("onboardingType")
                        .includes("MF")}
                      inputLabel="Bank Account Number"
                      error={!!error}
                      helperText={error?.message}
                    />
                  )}
                />
              </Grid2>
              <Grid2 size={6}>
                <Controller
                  name={`bankAccounts.${index}.confirmAccountNum`}
                  control={form.control}
                  rules={{
                    required: {
                      value: form.getValues("onboardingType").includes("MF"),
                      message: "Please confirm Account number",
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <GKTextField
                      {...field}
                      requiredField={form
                        .getValues("onboardingType")
                        .includes("MF")}
                      inputLabel="Confirm Bank Account Number"
                      error={!!error}
                      helperText={error?.message}
                    />
                  )}
                />
              </Grid2>
              <Grid2 size={6}>
                <Controller
                  name={`bankAccounts.${index}.ifsc`}
                  control={form.control}
                  rules={{
                    required: {
                      value: form.getValues("onboardingType").includes("MF"),
                      message: "Please enter Bank IFSC",
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <GKTextField
                      {...field}
                      requiredField={form
                        .getValues("onboardingType")
                        .includes("MF")}
                      inputLabel="IFSC Code"
                      error={!!error}
                      helperText={error?.message}
                    />
                  )}
                />
              </Grid2>
            </Grid2>
          );
        })}
      </Grid2>
    </Grid2>
  );
};

export default AdvisorOnboardingClientBank;
